import { StringAttribute } from 'domain/experiment/attribute';
import { Stage, StageConverter } from '@neptune/shared/entity-domain';

export function stringAttributeToStage(attribute: StringAttribute): Stage | undefined {
  const stringValue = attribute.value;
  return StageConverter.stringToStage(stringValue);
}
